// extracted by mini-css-extract-plugin
export default {"subTabs":"ProfileGestion_subTabs__W6QJK","subTab":"ProfileGestion_subTab__59MFJ","subTabActive":"ProfileGestion_subTabActive__h6Byf"};